export default __webpack_public_path__ + "static/media/boxSlipper2.ea74f761.png";